import { useEffect } from "react";
import { useDispatch } from "react-redux";

import { getAgentDevice, useCheckAgentType } from "../../../hooks/useCheckAgentType";
import { setUserData } from "../../../redux/reducers/user";
import { prepareUserFcmTokenRef } from "./useGetUserTokensRef";
import { applyUpdateTimestamp } from "../../../utils/timestamp";
import { User, UserRole } from "../../../types/user.types";

/**
 * mobile will inject this token in the url query param called `fcmToken`, we get it
 * and update current logged-in user token
 * */
export const useGetWebViewFcmToken = () => {
  const dispatch = useDispatch();
  const { isAndroidWebView, isIosWebView } = useCheckAgentType();

  useEffect(() => {
    if (isAndroidWebView || isIosWebView) {
      const searchParams = new URLSearchParams(window.location.search);
      dispatch(setUserData({ webviewFcmToken: searchParams.get("fcmToken") }));
    }
  }, [isAndroidWebView, isIosWebView, dispatch]);
};

export const resetWebViewUserToken = async (user: User) => {
  const { isAndroidWebView, isIosWebView } = getAgentDevice();
  if (isAndroidWebView || isIosWebView) {
    if (user && user.role !== UserRole.admin) {
      await prepareUserFcmTokenRef(user).update(
        applyUpdateTimestamp({
          fcmToken: null,
        })
      );
    }
  }
};
